import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnChanges, AfterViewChecked {

  display: boolean = false;

  public headerText: string = '';
  displayName: string = '';
  userRole: any = '';
  sharePointUrl = '';
  assetsUrl = '';
  fromCometFlag = false;
  helpGuideFlag = false;
  teamName:any = '';
  date: Date = new Date();
  @Input() user:any = {};
  @Input() isSuperAdminUser!:any;
  @Input() isLOBUser! : any;
  @Output() onLogoClick = new EventEmitter();
  @Input() officeManagerAgentSearch: any;
  public url : string = '';
  public teamRoleAssigned : any = '';
  public agentSearchTeamInfo: any = '';
  public isTeamLeader : boolean = false;
  @Input() isSearchedOfficeManagerUser: any;
  @Input() searchAgentInfoForHeader: any;
  @Input() isBranchAdminUser: any;
  @Output()
  onListClickEmit = new EventEmitter();
  @Output()
  onHomeEmit = new EventEmitter();
  @Output()
  onPortalEmit = new EventEmitter();
  @Output()
  onCoreEmit = new EventEmitter();
  @Input() teamInfo: any;
  @Input() searchAgentTeamInfo: any;
  @Input() isAgentUser: any;
  @Input() isOfficeManagerUser: any;  
  xcelerateUser: boolean = false;
  @ViewChild('headerClickConfirmation', {static: true})
  public headerClickConfirmation: SearchUpdateConfirmationComponent | any;
  constructor(private authService: AuthService,
    private router:Router,
    private cdr: ChangeDetectorRef,
    private commonSerice: CommonService) { 
      this.router.events?.subscribe((event) => {
        if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.url = event.url;
          this.authService.urlSubject.next(this.url);
        }, 100);
        }
      });
  }

  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
    this.checkTeamRole();
    this.commonSerice.xcelerateUserEmitter.subscribe((res: boolean) => {
      this.xcelerateUser = res;
    })
    this.commonSerice.subscribeToGoHome(() => {
      this.closeHeader()
    })
  }

  ngOnChanges(_changes: SimpleChanges) {
    if (!this.commonSerice.getIsDelegateLoggedIn()){
      if(this.user && this.user.firstName && this.user.lastName) {
        this.displayName = this.user.firstName + ' ' + this.user.lastName;
      }
    }
    else {
      let delegateUserInfo = this.commonSerice.getDelegateUserInfo();
      if(delegateUserInfo)
        this.displayName = delegateUserInfo?.First_Name + ' ' + delegateUserInfo?.Last_Name;
    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  /**
   * Return the current easter time
   */
  get time() {
    const estDate = this.date.toLocaleString('en-US', { timeZone: 'America/New_York' });
    const formatDate = moment(estDate).format('LLLL');
    return `${formatDate} EST`;
  }

  /** close sidebar header */
  closeSideBarHeader(_event: any) {
    this.commonSerice.showAgentView.next(true);
    this.display = false;    
  }


  /** Enabled flag for personal info sub menu */
  public get isPersonalInfoEnabled(): boolean {
    return this.url.includes('/personal-info');
  }

  /** Enabled flag for subscription sub menu */
  public get isSubscriptionEnabled(): boolean {
    return this.url.includes('/portal/subscriptions');
  }
  
   /** office websites sub menu */
   public get isOfficeWebsiteEnabled(): boolean {
    return this.url.includes('/portal/office-websites');
  }
  
/** Enabled flag for team leader sub menu */
  public get isTeamWebsiteEnabled(){
    return this.url.includes('/portal/team-website');
  }

   /** leads-crm menu show */
   public get isLeadsEnabled(): boolean {
    return this.url.includes('/portal/leads-crm');
  }

  /* emit event when logo is clicked */
  navigateToDashboard() {
    if(!this.xcelerateUser && !this.commonSerice.getIsDelegateLoggedIn()) {
      if(this.commonSerice.getFormUpdateStatus()) {
        this.headerClickConfirmation.showModal()
      } else {
        this.redirectToLandingPage();
      }
    }
  }

  redirectToLandingPage() {
    sessionStorage.removeItem('currentUrl');
    sessionStorage.removeItem('adminSearchData');
    sessionStorage.removeItem('coreServiceFromPortal');
    this.commonSerice.setFormUpdateStatus(false)
    if(this.commonSerice.isAgentUser()) {
      this.router.navigate(['/portal/personal-info/photos']);
    } else if(this.commonSerice.isOfficeManagerUser()) {
            this.commonSerice.setOfficeManagerAgentSitesClick(false); 
            this.commonSerice.setLastAgentSearchDetails(undefined)    
            this.commonSerice.officeManagerAgentSearchClick$.next(false);       
            } else {      
                this.onLogoClick.emit(true);      
              }    
  }

/**
 * check if the logged in agent is a team leader or a team member
 */
  public checkTeamRole(){
   this.teamName = this.teamInfo?.teamName ? this.teamInfo?.teamName : this.searchAgentTeamInfo?.teamName;
    this.teamRoleAssigned =  this.teamInfo?.teamRole;
    this.agentSearchTeamInfo = this.searchAgentTeamInfo?.teamRole;
    if (this.teamRoleAssigned === "Leader" ||  this.agentSearchTeamInfo === "Leader") {
      return true
    }
    return false;
  }

  /**on click of Portal manager menu */
  onPortalClick(event: any) {
    this.display = false;
    this.onPortalEmit.emit(event);
  }

  
  /**on click of website and listings menu */
  onListSearch(event: any) {
    this.onListClickEmit.emit(event);
  }


  
  /**on click of core service association menu */
  onCoreClick(event:any){
    this.onCoreEmit.emit(event);
  }


  closeHeader() {
    this.display = false;
    this.onHomeEmit.emit(true);
  }
}
